import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Paperclip, X, AlertTriangle } from "lucide-react";
import { fmtSize } from "./AssetPicker";

// Attachment names/sizes + availability, and any problems with files used in the body.
export function AssetAttachments({ items, bodyhtml, onRemove, testId = "assets" }) {
  const [chk, setChk] = useState(null);
  const key = JSON.stringify({ items, b: (bodyhtml || "").match(/\/api\/a\/[A-Za-z0-9_-]+/g) });
  useEffect(() => {
    const t = setTimeout(() => api.post("/comm-assets/check", { bodyhtml, attachments: items }).then((r) => setChk(r.data)).catch(() => {}), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  const rows = chk?.attachments || items.map((x) => ({ ...x, status: "ok" }));
  if (!rows.length && !chk?.issues?.length) return null;
  return (
    <div className="space-y-1.5" data-testid={`${testId}-panel`}>
      {rows.length > 0 && <p className="text-xs font-semibold text-slate-700">Attachments{chk ? ` · ${fmtSize(chk.total_size)} of ${fmtSize(chk.limit)} limit` : ""}</p>}
      <div className="flex flex-wrap gap-1.5">
        {rows.map((a) => (
          <span key={`${a.kind}-${a.id}`} data-testid={`${testId}-att-${a.id}`}
            className={`inline-flex items-center gap-1.5 text-xs rounded-full border px-2.5 py-1 ${a.status === "ok" ? "bg-slate-50 border-slate-200 text-slate-700" : "bg-rose-50 border-rose-200 text-rose-700"}`}>
            <Paperclip className="w-3 h-3" />{a.name || "file"} <span className="text-slate-400">{fmtSize(a.size)}</span>
            {a.status !== "ok" && <b>· {a.message}</b>}
            {onRemove && <button type="button" onClick={() => onRemove(a)} aria-label="Remove attachment" data-testid={`${testId}-remove-${a.id}`} className="hover:text-rose-600"><X className="w-3 h-3" /></button>}
          </span>
        ))}
      </div>
      {chk?.issues?.length > 0 && <div className="rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-900 space-y-1" data-testid={`${testId}-issues`}>
        {chk.issues.map((m) => <p key={m} className="flex gap-1.5"><AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />{m}</p>)}
      </div>}
    </div>
  );
}
